import { render } from "./NotificationBar.vue?vue&type=template&id=48e93ddc"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=48e93ddc&lang=css"
script.render = render

export default script